import { smartForestApi } from '../clients/AxiosClients'

/**
 * Lista todas as API Keys do customer autenticado
 * @returns {Promise} Lista de API Keys
 */
export const listApiKeys = () => {
	return smartForestApi.get('api/ApiKeys')
}

/**
 * Cria uma nova API Key
 * @param {Object} apiKeyData - Dados da API Key { name, accessLevel }
 * @returns {Promise} Resposta da API com a nova API Key
 */
export const createApiKey = (apiKeyData) => {
	return smartForestApi.post('api/ApiKeys', apiKeyData)
}

/**
 * Valida uma API Key
 * @param {string} key - API Key a validar
 * @returns {Promise} Informações da API Key se válida
 */
export const validateApiKey = (key) => {
	return smartForestApi.get(`api/ApiKeys/validate/${key}`)
}

/**
 * Revoga uma API Key
 * @param {string} key - API Key a revogar
 * @returns {Promise} Resultado da revogação
 */
export const revokeApiKey = (key) => {
	return smartForestApi.delete(`api/ApiKeys/${key}`)
}
